import { SelectFieldProps } from "components/Form/typings";
import TimezoneSelect from "components/Form/Select/TimezoneSelect";
import FormField from "../FormField";

export default function TimezoneSelectField({
  name,
  label,
  helperText,
  control,
  errors,
  required,
  disabled,
  variant,
  formFieldProps = {},
  size = "md",
  ...rest
}: SelectFieldProps & { size: "sm" | "md" }) {
  const formVariant = variant;
  const { labelProps = {}, ...restFormFieldProps } = formFieldProps;
  return (
    <FormField
      name={name}
      label={label}
      errors={errors}
      helperText={helperText}
      required={required}
      disabled={disabled}
      variant={formVariant}
      labelProps={{
        // this is hacky, just getting something done for now
        ...(formVariant === "floating" && size === "sm"
          ? {
              top: "0 !important",
              marginTop: "0px !important",
            }
          : {}),
        ...labelProps,
      }}
      {...restFormFieldProps}
    >
      <TimezoneSelect control={control} name={name} variant={formVariant} size={size} {...rest} />
    </FormField>
  );
}
